/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1FolderResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
} from '../models/index';
import {
    ApiResponse1FolderResponseFromJSON,
    ApiResponse1FolderResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
} from '../models/index';

export interface ApiFolderEditPostRequest {
    id?: number;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

export interface ApiFolderPostRequest {
    parentId?: number;
    projectId?: number;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

/**
 * 
 */
export class FolderApi extends runtime.BaseAPI {

    /**
     * **Required Roles:** AccountManager, SuperAdmin, AccountOwner  Bu endpoint bir folder üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir folder\'ı düzenler
     */
    async apiFolderEditPostRaw(requestParameters: ApiFolderEditPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FolderResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['id'] != null) {
            formParams.append('Id', requestParameters['id'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Folder/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FolderResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin, AccountOwner  Bu endpoint bir folder üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir folder\'ı düzenler
     */
    async apiFolderEditPost(requestParameters: ApiFolderEditPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FolderResponse> {
        const response = await this.apiFolderEditPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin, AccountOwner  Bu endpoint yeni bir folder oluşturur. Thumbnail yüklenebilir.
     * Yeni bir folder oluşturur
     */
    async apiFolderPostRaw(requestParameters: ApiFolderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1FolderResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['parentId'] != null) {
            formParams.append('ParentId', requestParameters['parentId'] as any);
        }

        if (requestParameters['projectId'] != null) {
            formParams.append('ProjectId', requestParameters['projectId'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Folder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1FolderResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** AccountManager, SuperAdmin, AccountOwner  Bu endpoint yeni bir folder oluşturur. Thumbnail yüklenebilir.
     * Yeni bir folder oluşturur
     */
    async apiFolderPost(requestParameters: ApiFolderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1FolderResponse> {
        const response = await this.apiFolderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
